import React from 'react';
import { IconProps } from '.';

const SvgBoxFingerOffFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z' />
      <path
        fill='#fff'
        d='M7.218 14.152c.065.062.43.123.796.185.324.054.648.109.763.163l.974-.811a9.37 9.37 0 0 0-.576-.142c-.53-.121-1.22-.28-1.47-.437-.365-.116-.487-.348-.487-.695 0-.464.365-.811.853-.811.121 0 .243 0 .365.116l1.218.463h.122c.243 0 .487-.232.487-.463V6.97c0-.464.365-.811.852-.811.488 0 .853.347.853.81v2.665c0-.463.365-.81.852-.81.488 0 .853.347.853.81v.216l.244-.216.243-.232L15.5 8.36l-.092-.045c-.2-.1-.377-.187-.76-.187h-.366c-.365-.232-.73-.348-1.096-.348v-.81c0-1.043-.975-1.97-2.07-1.97-1.097 0-2.071.927-2.071 1.97v3.591h-.122c-.244-.116-.609-.116-.852-.116-1.097 0-2.071.927-2.071 1.97 0 .81.365 1.506 1.218 1.737Z'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M9.228 17.137 7.808 18.5 7 17.718 17.64 7.5l.814.776-1.535 1.475c.087.18.19.38.348.637.117.634.233 1.396.233 2.157 0 1.649-.466 3.298-1.28 4.82-.234.381-.7.635-1.049.635h-4.774c-.465 0-.815-.254-1.048-.634a2.391 2.391 0 0 0-.121-.23Zm6.755-6.487L14 12.56l-1.73 1.662-1.452 1.4-.746.707c.082.153.146.322.209.53h4.774c.815-1.27 1.164-2.792 1.164-4.187 0-.635-.116-1.269-.233-1.903 0-.04 0-.08-.003-.119Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBoxFingerOffFill;
